import { useEffect, useRef, useState } from "react";

const PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

const APPEARANCE = {
  theme: "stripe",
  labels: "auto",
  inputs: "spaced",
  variables: {
    borderRadius: "4px",
    colorBackground: "#ffffff",
    colorDanger: "#df1b41",
    colorPrimary: "#0570de",
    colorSuccess: "#00c853",
    colorText: "#30313d",
    fontFamily: "default",
    fontSizeBase: "16px",
    spacingUnit: "4px",
  },
};

export default function EmbeddedCheckout({ clientSecret, onError }) {
  const containerRef = useRef(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!clientSecret || !containerRef.current) return undefined;
    if (!window.Stripe) {
      setFailed(true);
      onError?.("Payment form failed to load. Please refresh and try again.");
      return undefined;
    }
    let destroyed = false;
    let form;
    const stripe = window.Stripe(PUBLISHABLE_KEY);
    const clientSecretPromise = Promise.resolve(clientSecret);
    const checkout = stripe.initCheckoutFormSdk({ clientSecret: clientSecretPromise, appearance: APPEARANCE });
    (async () => {
      try {
        form = checkout.createForm({ layout: "expanded" });
        if (destroyed) return;
        form.mount(containerRef.current);
        const loadActionsResult = await checkout.loadActions();
        if (loadActionsResult.type === "success") {
          form.on("confirm", async (event) => {
            try {
              await loadActionsResult.actions.confirm({ formConfirmEvent: event });
            } catch (error) {
              console.error("Payment confirmation error:", error);
            }
          });
        }
      } catch (e) {
        if (!destroyed) {
          setFailed(true);
          onError?.("Payment form could not be displayed.");
        }
      }
    })();
    return () => {
      destroyed = true;
      try { form?.destroy(); } catch { /* already unmounted */ }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientSecret]);

  if (failed) return null;
  return <div id="checkout-form" ref={containerRef} data-testid="embedded-checkout-form" />;
}
